export const axisLinear = {
    domainLine: {
        visible: !1
    },
    grid: {
        visible: !0
    },
    subGrid: {
        visible: !1
    },
    tick: {
        visible: !1
    },
    subTick: {
        visible: !1
    }
};
//# sourceMappingURL=linear-axis.js.map
